import qs from 'qs';

let apiUri;

if (process.env.NODE_ENV === 'development') {
    apiUri = process.env.REACT_APP_API_URI_DEVELOPMENT;
} else {
    apiUri = process.env.REACT_APP_API_URI_PRODUCTION;
}

const artCollectionsQuery = qs.stringify({
    sort: ['Name:desc'],
    populate: {
        ordered_list: {
            populate: {
                art_piece: {
                    populate: '*'
                }
            }
        }
    }
}, { encodeValuesOnly: true });

export default {
    artPieceTags: (pieceID) =>
        `${apiUri}/art-pieces?filters[id]=${pieceID}&populate=*`,

    getPiecesFromTag: (tagName) =>
        `${apiUri}/art-pieces?filters[tags][name]=${encodeURIComponent(tagName)}&populate=*`,

    artCollections: `${apiUri}/art-collections?${artCollectionsQuery}`,
    translations: `${apiUri}/translation`,
    pages: `${apiUri}/pages?populate=*`,

    page: (pageUrl) =>
        `${apiUri}/pages?filters[url]=${encodeURIComponent(pageUrl)}&populate=*`,
};